import { render } from "./DocumentClassTablesSubView.vue?vue&type=template&id=2df8ce11&scoped=true&ts=true"
import script from "./DocumentClassTablesSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassTablesSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassTablesSubView.vue?vue&type=style&index=0&id=2df8ce11&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df8ce11"]])

export default __exports__